import App from 'home2021';

$(function() {
  App.init()
})


